import styled from 'styled-components';
import colors from 'Styles/colors';
import { disableTextSelection } from 'Styles/effects/text';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0;
  padding-right: 12px;
  overflow: auto;
  margin-right: 12px;
`;
Wrapper.displayName = 'Wrapper';

export const WrapperItem = styled.div`
  position: relative;
  display: flex;
  padding: 15px 20px 15px 20px;
  border-radius: 3px;
  box-shadow: 0 2px 15px 0 #e3e3e3;
  border: solid 1px ${colors.veryLightPink};
  background-color: ${colors.white};
  margin-bottom: 30px;
  flex-direction: column;
  text-align: left;
  ${({ selected }) => selected && `
    border: solid 3px #639efe;
    padding: 13px 18px 13px 18px;
  `}
  ${disableTextSelection}
`;
WrapperItem.displayName = 'WrapperItem';

export const Title = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: ${colors.black};
  margin-bottom: 3px;
  cursor: pointer;
`;
Title.displayName = 'Title';

export const Description = styled.div`
  font-size: 12.5px;
  line-height: 1.44;
  color: ${colors.grey19};
  margin-bottom: 10px;
`;
Description.displayName = 'Description';

export const Id = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #264d6d;
`;
Id.displayName = 'Id';
